import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Sale2310SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
    partyId: z.string().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    reasonCode: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Sale2310SearchParams = z.infer<typeof Sale2310SearchParamsSchema>

export const Sale2310SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  warehouseDocumentId: z.number().nullable().optional(),
  receivedCompleted: z.boolean(),
})

export type Sale2310SearchResultModel = z.infer<
  typeof Sale2310SearchResultModelSchema
>

export const Sale2310SearchResultSchema = z
  .object({
    data: z.array(Sale2310SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Sale2310SearchResult = z.infer<typeof Sale2310SearchResultSchema>
